// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zc-y","colMin":"styles_colMin__2UyhN"};